export class ErrorRequest {
	errorField1: string;
	errorField2: string;
	errorField3: string;
	errorField4: string;
	errorField5: string;
	errorID: number;
}
